"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStakingHelpers = exports.getAllHelpers = exports.StakingPoolHelper = exports.PoolHelper = exports.getPools = exports.bmath = void 0;
var subgraph_1 = require("./subgraph");
Object.defineProperty(exports, "getPools", { enumerable: true, get: function () { return subgraph_1.getPools; } });
__exportStar(require("./multicall"), exports);
var bmath = __importStar(require("./bmath"));
exports.bmath = bmath;
var pool_helper_1 = require("./pool-helper");
Object.defineProperty(exports, "PoolHelper", { enumerable: true, get: function () { return pool_helper_1.PoolHelper; } });
var initializer_helper_1 = require("./initializer-helper");
var provider_1 = require("./utils/provider");
__exportStar(require("./utils/bignumber"), exports);
var uniswap_helper_1 = require("./uniswap-helper");
Object.defineProperty(exports, "UniswapHelper", { enumerable: true, get: function () { return uniswap_helper_1.UniswapHelper; } });
var staking_1 = require("./staking");
Object.defineProperty(exports, "StakingPoolHelper", { enumerable: true, get: function () { return staking_1.StakingPoolHelper; } });
var new_staking_1 = require("./new-staking");
Object.defineProperty(exports, "NewStakingHelper", { enumerable: true, get: function () { return new_staking_1.NewStakingHelper; } });
function getAllHelpers(provider_, userAddress) {
    return __awaiter(this, void 0, void 0, function () {
        var provider, network, poolDatas, initialized, uninitialized, _i, poolDatas_1, poolData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    provider = provider_1.toProvider(provider_);
                    return [4 /*yield*/, provider.getNetwork()];
                case 1:
                    network = (_a.sent()).chainId === 1 ? 'mainnet' : 'rinkeby';
                    return [4 /*yield*/, subgraph_1.getPools(network)];
                case 2:
                    poolDatas = _a.sent();
                    initialized = [];
                    uninitialized = [];
                    for (_i = 0, poolDatas_1 = poolDatas; _i < poolDatas_1.length; _i++) {
                        poolData = poolDatas_1[_i];
                        if (poolData.isPublic) {
                            initialized.push(new pool_helper_1.PoolHelper(provider, network, poolData, userAddress));
                        }
                        else {
                            uninitialized.push(new initializer_helper_1.InitializerHelper(provider, network, poolData, userAddress));
                        }
                    }
                    return [2 /*return*/, { initialized: initialized, uninitialized: uninitialized }];
            }
        });
    });
}
exports.getAllHelpers = getAllHelpers;
function getStakingHelpers(provider_, userAddress) {
    return __awaiter(this, void 0, void 0, function () {
        var provider, network, stakingPools;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    provider = provider_1.toProvider(provider_);
                    return [4 /*yield*/, provider.getNetwork()];
                case 1:
                    network = (_a.sent()).chainId === 1 ? 'mainnet' : 'rinkeby';
                    return [4 /*yield*/, subgraph_1.getStakingPools(network)];
                case 2:
                    stakingPools = _a.sent();
                    return [2 /*return*/, stakingPools.map(function (pool) { return new staking_1.StakingPoolHelper(provider, network, pool, userAddress); })];
            }
        });
    });
}
exports.getStakingHelpers = getStakingHelpers;
